<script lang="ts">
  import type {
    NbaGameDataResponse,
    NbaPlayByPlayResponse,
    NbaStatKey,
  } from '@statmuse/core/gamera/index'
  import * as store from './stores'
  import { onMount } from 'svelte'
  import type { NbaPlayersMediaQuery } from '@statmuse/core/../graphql/graphql'

  export let gameData: NbaGameDataResponse<NbaStatKey>
  export let playByPlay: NbaPlayByPlayResponse
  export let players: Record<
    string,
    NonNullable<NbaPlayersMediaQuery['nba']['players']>[number] | undefined
  >

  onMount(() => {
    store.init({ gameData, playByPlay, players })
    // return () => store.gameState.set({})
  })
</script>
